export const gridStyle = {
  '.MuiDataGrid-root, .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  '.MuiDataGrid-toolbarContainer, .MuiDataGrid-columnHeaders, .MuiDataGrid-footerContainer':
    {
      backgroundColor: 'rgba(63,81,181,0.1)',
    },
  '.MuiDataGrid-columnHeaderTitle': {
    fontWeight: 700,
  },
};
export const ticketTabStyle = {
  '.MuiDataGrid-root, .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  '.MuiDataGrid-toolbarContainer, .MuiDataGrid-columnHeaders, .MuiDataGrid-footerContainer':
    {
      backgroundColor: 'rgba(63,81,181,0.1)',
    },
  '.MuiDataGrid-columnHeaderTitle': {
    fontWeight: 700,
  },
  '.MuiDataGrid-cell': {
    textTransform: 'capitalize',
  },
};

export const fieldTransform = {
  '.MuiAutocomplete-input': {
    textTransform: 'capitalize',
  },
};

export const viewBox = {
  minHeight: '86.4vh',
  borderRadius: 1,
  background: 'none',
  border: '1px solid rgba(224, 224, 224, 1)',
  boxShadow:
    '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
  color: 'black',
};

export const modalStyle1024 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  borderRadius: 2,
  p: 0.5,
  maxHeight: '80vh',
  overflow: 'scroll',
  overflowX: 'hidden',
};
export const modalStyle900 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  borderRadius: 2,
  p: 0.5,
  maxHeight: '80vh',
  overflow: 'scroll',
  overflowX: 'hidden',
};
export const modalStyle600 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  borderRadius: 2,
  p: 0.5,
  maxHeight: '80vh',
  overflow: 'scroll',
  overflowX: 'hidden',
};

export const ticketTypoTitle = {
  variant: 'subtitle2',
  fontWeight: '700',
};
export const ticketTypoInfo = {
  variant: 'subtitle2',
  fontWeight: '500',
};
